// @ts-nocheck
/* eslint-disable */
import { node, icon } from "~/util/dom";

/**
 * Pocet zobrazeni fotky do galerie
 */
export function viewCount(count) {
	const elm = node("div", { className: `view-count`, title: Mapy.Util.formatLocaleNumber(count) }, count ? Mapy.Util.formatLocaleNumber(count) : "");

	if (count) {
		elm.firstChild.before(icon("view-count"));
	}

	return elm;
};
